import { createReducer } from './utils.js';
import {
  GET_MASIVOS_REQUEST,
  GET_MASIVOS_SUCCESS,
  GET_MASIVOS_FAILURE,
  SNACK_SET,
} from './constants.js';

const defaultState = {
  loading: false,
  errorMessage: null,
  masivos: [],
};

export const reducer = createReducer(defaultState, {
  [GET_MASIVOS_REQUEST]: handleGetMasivosRequest,
  [GET_MASIVOS_SUCCESS]: handleGetMasivosSuccess,
  [GET_MASIVOS_FAILURE]: handleGetMasivosFailure,
});

function handleGetMasivosRequest(state) {
  return {
    ...state,
    masivos: [],
    loading: true,
  };
}

function handleGetMasivosSuccess(state, { payload: { masivos } }) {
  return {
    ...state,
    masivos,
    loading: false,
    errorMessage: null,
  };
}

function handleGetMasivosFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error,
  };
}

export function getMasivos(tenant_id, sucursal_id) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: GET_MASIVOS_REQUEST });
    try {
      const masivos = await dataSource.getMasivos(tenant_id, sucursal_id);
      dispatch({ type: GET_MASIVOS_SUCCESS, payload: { masivos } });
    } catch (error) {
      dispatch({ type: GET_MASIVOS_FAILURE, payload: { error } });
      const snack = {
        open: true,
        message: 'Error al obtener los masivos' + error.message,
        severity: 'error',
      };
      dispatch({
        type: SNACK_SET,
        payload: { snack },
      });
    }
  };
}
